'use client'
import { createContext, useContext, useState } from 'react'
import type { WhatsUpResponse } from './entities'
import { whatsUp } from './use-cases'

type WhatsupContextType = Partial<WhatsUpResponse> & {
  getWhatsUp: () => Promise<void>
}

const WhatsUpContext = createContext<WhatsupContextType>({
  phoneVerificationRequired: false,
  getWhatsUp: async () => {},
})

export function WhatsUpProvider({
  children,
  initialState,
}: {
  children: React.ReactNode
  initialState: WhatsUpResponse | null
}) {
  const [whatsUpState, setWhatsUpState] = useState<WhatsUpResponse | null>(initialState)

  const getWhatsUp = async () => {
    const response = await whatsUp('phoneVerificationRequired')
    setWhatsUpState(response)
  }

  const value: WhatsupContextType = {
    ...whatsUpState,
    getWhatsUp,
  }

  return <WhatsUpContext.Provider value={value}>{children}</WhatsUpContext.Provider>
}

export function useWhatsUp() {
  const context = useContext(WhatsUpContext)
  if (!context) {
    throw new Error('useWhatsUp must be used inside a <WhatsupContext>')
  }
  return context
}
